import styled from '@emotion/styled';

import {
  MainLineBannerSection,
} from '../../../interfaces/MainSection.interface';
import SectionContents from '../shared/SectionContents';
import MainSectionLoadingSpinner from '../shared/MainSectionLoadingSpinner';

import { amplitudeService } from '../../../../shared/amplitude';
import { SelectRecommendation } from '../../../../shared/amplitude/events';
import { useAppSelector } from '../../../../shared/store';

const Link = styled.a`
  position: relative;
  display: block;
  overflow: hidden;
  height: 140px;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Text = styled.div<{ color: string; }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 50px;
  color: ${({ color }) => color};
`;

const Title = styled.strong`
  display: block;
  font-size: 28px;
  font-weight: 500;
  line-height: 1.36;
  letter-spacing: normal;
`;

const SubTitle = styled.span`
  display: block;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: normal;
  margin-top: 6px;
`;

interface Props {
  section: MainLineBannerSection;
}

export default function MainLineBanner({ section }: Props){
  const { isLoading, payload } = section;

  const { sections } = useAppSelector(({ main }) => main);

  const loadingLayer = <MainSectionLoadingSpinner/>;

  if (isLoading || !payload) {
    return <SectionContents section={section} loadingLayer={loadingLayer}/>;
  }

  const { bannerType, image, text, title, link } = payload;

  const selectBanner = () => {
    amplitudeService.logEvent(new SelectRecommendation({
      eventName: section.type,
      sectionType: 'content',
      target: section.id,
      sections,
      section,
    }));
  };

  if (bannerType === 'TEXT') {
    return (
      <SectionContents section={section}>
        <Link href={link} onClick={selectBanner}>
          <Text color={text.textColor}>
            <Title>{title}</Title>
            <SubTitle>{text.subtitle}</SubTitle>
          </Text>
        </Link>
      </SectionContents>
    );
  }

  return (
    <SectionContents section={section}>
      <Link href={link} onClick={selectBanner}>
        <img src={image.imageUrl} alt={title} />
      </Link>
    </SectionContents>
  );
}
